import { render } from "./SkillscardsPage.vue?vue&type=template&id=5b3420ae&scoped=true&ts=true"
import script from "./SkillscardsPage.vue?vue&type=script&lang=ts"
export * from "./SkillscardsPage.vue?vue&type=script&lang=ts"

import "./SkillscardsPage.vue?vue&type=style&index=0&id=5b3420ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3420ae"]])

export default __exports__